/**
 * Sets the active admin page
 *
 * @param {string} activePage - The key of the page to set as active
 * @return {Object} Action object
 */
export function setActivePage(activePage) {
	return {
		type: 'SET_ACTIVE_PAGE',
		activePage,
	};
}
